module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Scheduled Runs")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Search upcoming runs by trainer, date and run details")])]), _vm._v(" "), _c('span', {
    staticClass: "sr-total-badge"
  }, [_vm._v(_vm._s(_vm.totalElements) + " scheduled")])]), _vm._v(" "), _c('div', {
    staticClass: "sr-filter-card"
  }, [_c('div', {
    staticClass: "sr-card-header"
  }, [_c('span', {
    staticClass: "sr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 21l-4.35-4.35"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "sr-card-title"
  }, [_vm._v("Run Filters")]), _vm._v(" "), _c('p', {
    staticClass: "sr-card-subtitle"
  }, [_vm._v("Narrow the scheduled queue without leaving the list")])])]), _vm._v(" "), _c('div', {
    staticClass: "sr-controls"
  }, [_c('div', {
    staticClass: "sr-control-group sr-control-group--query"
  }, [_c('label', {
    staticClass: "sr-control-label"
  }, [_vm._v("Search Run")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.query),
      expression: "filters.query"
    }],
    staticClass: "sr-control-input",
    attrs: {
      "type": "text",
      "placeholder": "Run name or ID"
    },
    domProps: {
      "value": (_vm.filters.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.performSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "query", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sr-control-group"
  }, [_c('label', {
    staticClass: "sr-control-label"
  }, [_vm._v("Trainer")]), _vm._v(" "), _c('span', {
    staticClass: "sr-select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.trainerId),
      expression: "filters.trainerId"
    }],
    staticClass: "sr-control-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "trainerId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.performSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Trainers")]), _vm._v(" "), _vm._l((_vm.allTrainers), function(t) {
    return _c('option', {
      key: t.id,
      domProps: {
        "value": t.id
      }
    }, [_vm._v("\n                  " + _vm._s(t.firstName) + " " + _vm._s(t.lastName) + "\n              ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "sr-control-group"
  }, [_c('label', {
    staticClass: "sr-control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.date),
      expression: "filters.date"
    }],
    staticClass: "sr-control-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.date)
    },
    on: {
      "change": _vm.performSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "sr-search-btn",
    on: {
      "click": _vm.performSearch
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 21l-4.35-4.35"
    }
  })]), _vm._v("\n        Search\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sr-list-card"
  }, [_c('div', {
    staticClass: "sr-card-header sr-card-header--list"
  }, [_c('span', {
    staticClass: "sr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4M8 2v4M3 10h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "sr-card-title"
  }, [_vm._v("Upcoming Runs")]), _vm._v(" "), _c('p', {
    staticClass: "sr-card-subtitle"
  }, [_vm._v("Review future runs and resume live run operations")])]), _vm._v(" "), _c('span', {
    staticClass: "sr-mode-badge"
  }, [_vm._v(_vm._s(_vm.filters.pageSize) + " per page")])]), _vm._v(" "), (_vm.scheduledRunsLoading) ? _c('div', {
    staticClass: "sr-table-skeleton"
  }, [_c('div', {
    staticClass: "sr-skeleton-header"
  }, _vm._l((8), function(n) {
    return _c('div', {
      key: 'sr-head-' + n,
      staticClass: "sr-sk-cell sk-shimmer"
    })
  }), 0), _vm._v(" "), _vm._l((7), function(row) {
    return _c('div', {
      key: 'sr-row-' + row,
      staticClass: "sr-skeleton-row"
    }, _vm._l((8), function(col) {
      return _c('div', {
        key: 'sr-cell-' + row + '-' + col,
        staticClass: "sr-sk-cell sk-shimmer"
      })
    }), 0)
  })], 2) : _c('race-table-list', {
    attrs: {
      "races": _vm.racesScheduled,
      "message-empty-list": "There are no scheduled runs",
      "table-title": "Scheduled Runs",
      "table-subtitle": "Review upcoming runs and open live operation details",
      "empty-title": "No scheduled runs found",
      "date-field": "date",
      "type": "resume"
    }
  })], 1), _vm._v(" "), (!_vm.scheduledRunsLoading && _vm.totalElements > 0) ? _c('div', {
    staticClass: "sr-pagination-container"
  }, [_c('paginate', {
    attrs: {
      "page-count": Math.ceil(_vm.totalElements / _vm.filters.pageSize),
      "page-range": 7,
      "margin-pages": 2,
      "click-handler": _vm.changePageHandler,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination custom-pagination',
      "page-class": 'page-item'
    },
    model: {
      value: (_vm.filters.pageNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pageNo", $$v)
      },
      expression: "filters.pageNo"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9c92748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/ScheduledRuns.vue
// module id = 1755
// module chunks = 2